import { getLocalizedUrl } from '@js/App/Plugins/LocalizedUrls'

export const onClickLogoutUser = () => {
  window.location.href = getLocalizedUrl('logout')
}
